var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"case-row row hidden-md hidden-lg"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.casePhoto}})])}
var staticRenderFns = []

export { render, staticRenderFns }